export default __webpack_public_path__ + "static/media/auto.9d0d7a90.png";